// extracted by mini-css-extract-plugin
export var cardContainer = "_pq-0";
export var cardHeader = "_pq-2";
export var collapsedState = "_pq-3";
export var dragHandle = "_pq-5";
export var dragHandleIcon = "_pq-6";
export var dragging = "_pq-1";
export var titleArea = "_pq-4";